export type WidgetType = "kpi" | "table" | "line" | "bar" | "pie";
export type WidgetSourceKind = "integration" | "executions";
export type WidgetAggregate = "sum" | "count" | "avg" | "min" | "max" | "none";
export type ExecutionMetric =
  | "statusCounts"
  | "runsPerDay"
  | "recentRuns"
  | "successRate"
  | "avgDurationMs";

export interface WidgetLayout {
  w: number; // 1-4 (grid de 4 columnas)
  h: number; // 1-3
  x?: number | null;
  y?: number | null;
}

export interface WidgetSource {
  kind: WidgetSourceKind;
  providerId?: string | null;
  operationId?: string | null;
  parameters?: Record<string, unknown> | null;
  metric?: ExecutionMetric | null;
  days?: number | null;
  limit?: number | null;
  /**
   * Solo para `executions`: limita la métrica a una automatización del workspace.
   * `null` agrega **todas** las del workspace, que es el sentido de tener el dashboard a este nivel.
   */
  workflowId?: string | null;
}

export interface WidgetGroupBy {
  path: string;
  dateBucket?: "day" | null;
}

export interface WidgetColumn {
  path: string;
  header?: string | null;
}

export interface WidgetBinding {
  itemsPath?: string | null;
  labelPath?: string | null;
  valuePath?: string | null;
  aggregate?: WidgetAggregate | null;
  groupBy?: WidgetGroupBy | null;
  columns?: WidgetColumn[] | null;
}

export interface WidgetSpec {
  id: string;
  title: string;
  type: WidgetType;
  layout: WidgetLayout;
  refreshSeconds?: number | null;
  source: WidgetSource;
  binding?: WidgetBinding | null;
}

export const EXECUTION_METRIC_LABELS: Record<ExecutionMetric, string> = {
  statusCounts: "Ejecuciones por estado",
  runsPerDay: "Ejecuciones por día",
  recentRuns: "Ejecuciones recientes",
  successRate: "Tasa de éxito (%)",
  avgDurationMs: "Duración promedio (ms)",
};

export const WIDGET_TYPE_LABELS: Record<WidgetType, string> = {
  kpi: "KPI",
  table: "Tabla",
  line: "Línea",
  bar: "Barras",
  pie: "Circular",
};
